export const ADD_MESSAGE = 'ADD_MESSAGE';
export const ADD_MESSAGES = 'ADD_MESSAGES';
export const SET_MESSAGES = 'SET_MESSAGES';
export const MERGE_MESSAGES = 'MERGE_MESSAGES';
export const REJECT_MESSAGE = 'REJECT_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const REPLACE_MESSAGE = 'REPLACE_MESSAGE';
export const ADD_PARTICIPANT = 'ADD_PARTICIPANT';
export const REMOVE_PARTICIPANT = 'REMOVE_PARTICIPANT';
export const SET_CONVERSATION = 'SET_CONVERSATION';
export const SET_CONVERSATIONS = 'SET_CONVERSATIONS';
export const RESET_CONVERSATION = 'RESET_CONVERSATION';
export const RESET_UNREAD_COUNT = 'RESET_UNREAD_COUNT';
export const ADD_COMPLETED_UPLOAD = 'ADD_COMPLETED_UPLOAD';
export const REFRESH_CONVERSATIONS = 'REFRESH_CONVERSATIONS';
export const INCREMENT_UNREAD_COUNT = 'INCREMENT_UNREAD_COUNT';
// TODO: explore removing SET_APP_MAKER_LAST_READ and treat the appMaker as a participant in the conversations reducer
export const SET_APP_MAKER_LAST_READ = 'SET_APP_MAKER_LAST_READ';
export const SET_PARTICIPANT_LAST_READ = 'SET_PARTICIPANT_LAST_READ';
export const REMOVE_COMPLETED_UPLOAD = 'REMOVE_COMPLETED_UPLOAD';
export const SET_FETCHING_MORE_MESSAGES_FROM_SERVER = 'SET_FETCHING_MORE_MESSAGES_FROM_SERVER';
export const SET_LAST_RECEIVED_MESSAGE_ID = 'SET_LAST_RECEIVED_MESSAGE_ID';
export const SET_COMPLETED_PRECHAT_CAPTURE = 'SET_COMPLETED_PRECHAT_CAPTURE';
export const SET_COMPLETED_PRECHAT_CAPTURE_LINKING = 'SET_COMPLETED_PRECHAT_CAPTURE_LINKING';
export const SET_LATEST_APPUSER_MESSAGE_TIMESTAMP = 'SET_LATEST_APPUSER_MESSAGE_TIMESTAMP';
